import {SET_SELECTED_CAT} from '../actions';

const initialState = {
	category: 1,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_CAT:
            return action.payload;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/selectedCat-reducer.js